export default "/react/logoBorisBot-081e7619.png";